module.exports = __webpack_public_path__ + "static/media/havwoods.76cc4ffe.png";